angular.module('Rebalancer',  [])
.controller('RebalanceAccountListCtrl', function($rootScope, $scope, SmartXFactory, IdentityFactory){
	var vm = this;
	
	vm.token = SmartXFactory.getToken();
	vm.env = SmartXFactory.getEnv();
	vm.authority = IdentityFactory.getAuthority();

	// $scope.$on('smx-token-updated', function(e, token) {
	// 	vm.token = token;
	// });

	init();

	function init(){}
});